
























































































import { Component, Vue, Watch, Ref } from 'vue-property-decorator';
import Calendar from '@/components/Retailer/BookingCalendar/Calendar.vue';
import PersonList from '@/components/Retailer/BookingCalendar/PersonList.vue';
import BookingForm from '@/components/Retailer/BookingCalendar/BookingForm.vue';
import HomeAndVideoMeetingBookingForm from '@/components/Retailer/HomeAndVideoMeetingBookingForm.vue';
import HomeMeetingCompletionForm from '@/components/Retailer/HomeMeetingCompletionForm.vue';
import RetailerMeetingSearch from '@/components/Retailer/RetailerMeetingSearch.vue';
import IdentityVerification from '@/components/Retailer/IdentityVerification.vue';
import { Slot, TimeSpan, Meeting, HomeAndVideoMeeting } from '@/models/CalendarEntries';
import { Marker } from '@/models/Retailer';
import { Person } from '@/models/Person';
import http from '@/services/Http';
import { MeetingCalendarStore } from '@/store/meetingcalendarstate';
import { PhoneCountryCode } from '@/models/PhoneCountryCode';

declare var grecaptcha: any;

@Component({
    components: {
        Calendar,
        PersonList,
        BookingForm,
        HomeAndVideoMeetingBookingForm,
        HomeMeetingCompletionForm,
        RetailerMeetingSearch,
        IdentityVerification
    }
})
export default class RetailerMeetingBooking extends Vue {
    [x: string]: any;
    @Ref('meetingContainer') meetingContainer!: HTMLDivElement;
    @Ref('completionForm') completionForm!: HTMLDivElement;
    // "stringname".AsWebsiteTextDefinition("En", "Sv", "No", bothSites, clientAvaliable: true, serverAvaliable: false),
    meetingType!: string;
    slots: Slot[] = [] as Slot[];
    persons: Person[] = [] as Person[];
    bookingSuccessful: boolean = false;
    completionSuccessful: boolean = false;
    selectedOrgId: string = '';
    selectedOrgName: string = '';
    slotsLoaded: boolean = false;
    personsLoaded: boolean = false;
    submitedBookingId: string = '';
    submitedPersonId: string = '';
    countryCodes: PhoneCountryCode[];
    infoNote: string = '';
    pageInfoNote: string = '';
    dataLayer = (window as any).dataLayer || [];
    requestLoading: boolean = false;
    idVerificationPending: boolean = false;
    idVerified: boolean = false;
    currentCulture: string = 'sv-SE';
    showNoTimes: boolean = false;

    get showRetailerSearch(): boolean {
        if (!this.bookingSuccessful && !this.isRetailerSite && !this.idVerificationPending) {
            return true;
        } else {
            return false;
        }
    }
    get isHomeOrVideo2MeetingBooking(): boolean {
        return this.meetingType === 'home' || this.meetingType === 'video2';
    }
    get foundActiveSlots(): boolean {
        console.log("filteredTimeSpans", this.filteredTimeSpans);
        return this.filteredTimeSpans.length > 0;
    }
    get dataLoaded(): boolean {
        return this.persons.length > 0 && this.slots.length > 0;
    }
    get selectedSlot(): Slot | undefined {
        const selectedPerson = MeetingCalendarStore.getSelectedMeetingPerson;
        const selectedTimeSpan = MeetingCalendarStore.getSelectedMeetingTimeSpan;
        if (typeof selectedPerson !== 'undefined' && selectedTimeSpan !== null) {
            return this.slots.find((x: Slot) => {
                return x.startDate === selectedTimeSpan.startDate && x.person === selectedPerson.id;
            });
        }
        return undefined;
    }
    get selectedSlots(): Slot[] {
        const selectedPerson = MeetingCalendarStore.getSelectedMeetingPerson;
        const selectedTimeSpan = MeetingCalendarStore.getSelectedMeetingTimeSpan;
        let returnArray = [] as Slot[];
        if (selectedTimeSpan !== null) {
            returnArray = this.slots.filter((x: Slot) => {
                return x.startDate === selectedTimeSpan.startDate;
            });
        }
        if (returnArray !== undefined) {
            return returnArray;
        }
        return [] as Slot[];
    }
    get showBookingForm(): boolean {
        console.log("ShowBookingForm");
        console.log("bookingSuccessful", this.bookingSuccessful);
        console.log("meetingType", this.meetingType);
        console.log("slotsLoaded", this.slotsLoaded);
        console.log("isRetailerSite", this.isRetailerSite);
        console.log("foundActiveSlots", this.foundActiveSlots);
        console.log("selectedOrgId", this.selectedOrgId);
        if (this.bookingSuccessful || this.meetingType === 'home' || this.meetingType === 'video2') {
            console.log("false 1");
            return false;
        } else if (this.slotsLoaded && this.isRetailerSite && this.foundActiveSlots) {
            console.log("true 1");
            return true;
        } else if (!this.isRetailerSite && this.selectedOrgId !== '' && this.foundActiveSlots) {
            console.log("true 2");
            return true;
        }
        return false;
    }
    get showHomeMeetingForm(): boolean {
        if (this.bookingSuccessful || this.idVerificationPending) {
            return false;
        } else if (!this.isRetailerSite && this.selectedOrgId !== '' && (this.meetingType === 'home' || this.meetingType === 'video2')) {
            return true;
        } else if (this.isRetailerSite && (this.meetingType === 'home' || this.meetingType === 'video2')) {
            return true;
        }
        return false;
    }
    get showHomeMeetingCompletion(): boolean {
        if (
            this.bookingSuccessful &&
            !this.completionSuccessful &&
            ((this.meetingType === 'home' &&
                this.submitedBookingId !== '' &&
                this.idVerified &&
                !this.idVerificationPending) ||
                (this.meetingType === 'video' || this.meetingType === 'video2' || this.meetingType === 'store'))
        ) {
            return true;
        }
        return false;
    }
    get personFilteredStartDates(): string[] {
        if (
            typeof MeetingCalendarStore.getSelectedMeetingPerson === 'undefined' ||
            MeetingCalendarStore.getSelectedMeetingPerson === null
        ) {
            return [];
        }
        const selectedPerson = MeetingCalendarStore.getSelectedMeetingPerson;
        return this.slots.reduce((filtered: string[], x: Slot) => {
            if (x.person === selectedPerson.id) {
                filtered.push(x.startDate);
            }
            return filtered;
        }, []);
    }
    get isRetailerSite(): boolean {
        return this.$attrs['data-is-retailer-site'] === 'True';
    }
    get filteredTimeSpans(): TimeSpan[] {
        const returnArray: TimeSpan[] = [] as TimeSpan[];
        const oneDayAhead: Date = new Date();
        oneDayAhead.setDate(oneDayAhead.getDate() + 1);
        for (let a = 0; a < this.slots.length; a++) {
            const dateOneDayAhead = new Date(Date.parse(this.slots[a].startDate)).getTime() >= oneDayAhead.getTime();
            const personActive = this.filteredPersons.some((x: Person) => {
                return x.id === this.slots[a].person;
            });
            let isDisabled: boolean = false;
            if (this.personFilteredStartDates.length > 0) {
                isDisabled = this.personFilteredStartDates.indexOf(this.slots[a].startDate) === -1;
            }
            if (dateOneDayAhead && personActive) {
                returnArray.push({
                    startDate: this.slots[a].startDate,
                    endDate: this.slots[a].endDate,
                    disabled: isDisabled
                } as TimeSpan);
            }
        }

        if (returnArray.length === 0) {
            this.showNoTimes = true;
        }
        else {
            this.showNoTimes = false;
        }

        return [...new Map(returnArray.map(item => [item['startDate'], item])).values()].sort(
            (a: TimeSpan, b: TimeSpan) => a.startDate.localeCompare(b.startDate)
        );
    }
    get filteredPersons(): Person[] {
        return this.persons.filter((x: Person) => {
            return this.slots.some((y: Slot) => {
                let compatibleMeetingType = false;
                if (this.meetingType === 'store' && x.inStoreMeetings) {
                    compatibleMeetingType = true;
                } else if (this.meetingType === 'video' && x.videoMeetings) {
                    compatibleMeetingType = true;
                }
                return y.person === x.id && compatibleMeetingType;
            });
        });
    }
    constructor() {
        super();
        this.meetingType = this.$attrs['data-meeting-type'];
        this.selectedOrgName = this.$attrs['data-retailer-name'];
        this.infoNote = this.$attrs['data-info-note'];
        this.pageInfoNote = this.$attrs['data-page-info-note'];
        this.currentCulture = this.$attrs['data-culture'];
        this.countryCodes = JSON.parse(this.$attrs['data-country-codes']);

        if (this.isRetailerSite && (this.meetingType !== 'home' && this.meetingType !== 'video2')) {
            this.$nextTick(() => {
                this.getSlots();
                this.getPersons();
            });
        }
    }
    mounted() {
        //If meetingId exists we complete ID verification
        if (typeof this.$route.query.meetingId !== 'undefined' && !this.idVerified) {
            this.submitedBookingId = this.$route.query.meetingId as string;
            this.idVerificationPending = true;
            this.idVerified = false;
        }
    }
    @Watch('selectedSlots')
    slotsUpdated() {
        if (this.selectedSlots.length === 1) {
            const onlyPersonAvailable = this.persons.find((p: Person) => {
                return p.id === this.selectedSlots[0].person;
            });
            if (onlyPersonAvailable !== undefined) {
                MeetingCalendarStore.setSelectedMeetingPerson(onlyPersonAvailable);
            }
        }
    }
    public handleVerificationCompleted() {
        this.idVerified = true;
        this.idVerificationPending = false;
        this.bookingSuccessful = true;

        const url = new URL(window.location.href);
        url.searchParams.set('bookedmeetingconfirmedVHH', 'true');
        window.history.pushState({}, '', url.toString());
        /*if (this.isRetailerSite) {
            this.meetingContainer.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        } else {
            //Scroll after 250ms to give time for the completion form to render
            setTimeout(() => {
                this.completionForm.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 500);
        }*/
    }
    public setSelectedRetailer(retailer: Marker) {
        if (typeof retailer === 'undefined') {
            return;
        }
        this.selectedOrgId = retailer.organizationId as string;
        this.selectedOrgName = retailer.name as string;
        if (this.meetingType !== 'home' && this.meetingType !== 'video2') {
            this.getSlots();
            this.getPersons();
        }
    }
    public verifySubmitHomeAndVideoMeetingBooking(formData: HomeAndVideoMeeting) {
        if (typeof this.meetingType === 'undefined') {
            return;
        }

        const recaptchaSiteKey = (window as any).__litium.recaptchaSiteKey as string;

        const submit = this.submitHomeAndVideoMeetingBooking;
        grecaptcha.ready(function() {
            grecaptcha
                .execute(recaptchaSiteKey, {
                    action: 'submit'
                })
                .then(function(token: string) {
                    formData.token = token;
                    submit(formData);
                });
        });
    }
    public verifySubmitHomeMeetingCompletion(formData: FormData) {
        if (typeof this.meetingType === 'undefined') {
            return;
        }

        const recaptchaSiteKey = (window as any).__litium.recaptchaSiteKey as string;

        const submit = this.submitHomeMeetingCompletion;
        grecaptcha.ready(function() {
            grecaptcha
                .execute(recaptchaSiteKey, {
                    action: 'submit'
                })
                .then(function(token: string) {
                    formData.append('token', token);
                    submit(formData);
                });
        });
    }
    public submitBooking(formData: Meeting) {
        if (typeof this.selectedSlot === 'undefined') {
            return;
        }
        if (typeof this.meetingType === 'undefined') {
            return;
        }
        formData.meetingType = this.meetingType;
        formData.startDate = this.selectedSlot.startDate;
        formData.endDate = this.selectedSlot.endDate;
        formData.person = this.selectedSlot.person as string;

        const recaptchaSiteKey = (window as any).__litium.recaptchaSiteKey as string;

        const submit = this.submitBooking2;
        grecaptcha.ready(function() {
            grecaptcha
                .execute(recaptchaSiteKey, {
                    action: 'submit'
                })
                .then(function(token: string) {
                    formData.token = token;
                    submit(formData);
                });
        });
    }

    private submitHomeAndVideoMeetingBooking(formData: HomeAndVideoMeeting) {
        formData.organizationId = this.selectedOrgId;
        this.requestLoading = true;
        const bookMeeting = http.post('/api/homemeetings/', formData);
        bookMeeting
            .then((response: any) => {
                this.requestLoading = false;
                const data = response.json();
                data.then((id: any) => {

                    console.log("success", data, id)
                    //const source = this.isRetailerSite ? 'retailer-web' : 'central-web';
                    //this.bookingSuccessful = true;
                    if (this.meetingType === 'home') {
                        this.idVerificationPending = true;
                        this.submitedBookingId = id;
                    }
                    else {
                        this.bookingSuccessful = true;
                        this.submitedBookingId = id;
                    }
                    this.matomoEvent("Meeting booked", this.selectedOrgName, this.meetingType);
                    this.matomoEvent("Meeting request (customer)", this.selectedOrgName, this.meetingType);
                }).catch((e: any) => {
                    console.error(e);
                });
            })
            .catch((e: any) => {
                this.requestLoading = false;
                console.error(e);
            });
    }

    private async submitHomeMeetingCompletion(formData: FormData) {
        console.log("submitHomeMeetingCompletion", formData);
        if (typeof this.$route.query.retailer !== 'undefined') {
            formData.append('organizationId', this.$route.query.retailer as string);
        } else if (typeof this.selectedOrgId !== 'undefined') {
            formData.append('organizationId', this.selectedOrgId);
        }

        if (this.meetingType === 'video' || this.meetingType === 'store') {
            formData.append('person', this.submitedPersonId);
            // formData.append('id', this.submitedBookingId)
        }

        this.requestLoading = true;
        const requestContext = (window as any).__litium.requestContext;
        const requestHeaders: HeadersInit = new Headers();
        requestHeaders.append('litium-request-context', JSON.stringify(requestContext));
        const settings = {
            method: 'POST',
            headers: requestHeaders,
            body: formData
        };
        try {
            const fetchResponse = await fetch('/api/meetingadditionalinfo', settings);
            //const data = await fetchResponse.json();
            this.requestLoading = false;
            if (!fetchResponse.ok) {
                throw new Error('Failed to complete booking');
            }
            /*
            this.meetingContainer.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            */
            const source = this.isRetailerSite ? 'retailer-web' : 'central-web';
            if (source === 'central-web') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            this.completionSuccessful = true;
        } catch (e) {
            return e;
        }
    }

    private submitBooking2(formData: Meeting) {
        const bookMeeting = http.post('/api/meetings/', formData);
        bookMeeting
            .then((response: any) => {
                const data = response.json();
                data.then((id: any) => {

                    this.submitedBookingId = id;
                    this.submitedPersonId = formData.person;

                    const selectedMeetingPerson = MeetingCalendarStore.getSelectedMeetingPerson;
                    const source = this.isRetailerSite ? 'retailer-web' : 'central-web';
                    this.bookingSuccessful = true;
                    /*this.meetingContainer.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'nearest'
                    });*/
                    this.matomoEvent("Meeting booked", this.selectedOrgName, this.meetingType);
                    const url = new URL(window.location.href);
                    url.searchParams.set('bookedmeetingconfirmedVHH', 'true');
                    window.history.pushState({}, '', url.toString());

                    this.dataLayer.push({
                        event: 'reseller-meeting',
                        'reseller-meetingtype': formData.meetingType,
                        staff: selectedMeetingPerson.title + '-' + selectedMeetingPerson.lastName,
                        email: formData.customerEmail,
                        store: this.selectedOrgName,
                        source: source
                    });
                }).catch((e: any) => {
                    console.error(e);
                });

                // const selectedMeetingPerson = MeetingCalendarStore.getSelectedMeetingPerson;
                // const source = this.isRetailerSite ? 'retailer-web' : 'central-web';
                // this.bookingSuccessful = true;
                // this.submitedPersonId = formData.person;
                // console.log("respone", response);
                // this.submitedBookingId = response.data;
                // window.scrollTo({ top: 0, behavior: 'smooth' });
                // this.dataLayer.push({
                //     event: 'reseller-meeting',
                //     'reseller-meetingtype': formData.meetingType,
                //     staff: selectedMeetingPerson.title + '-' + selectedMeetingPerson.lastName,
                //     email: formData.customerEmail,
                //     store: this.selectedOrgName,
                //     source: source
                // });
            })
            .catch((e: any) => {
                console.error(e);
            });
    }

    private getSlots() {
        this.slotsLoaded = false;
        const path = this.isRetailerSite
            ? '/api/slots/' + this.meetingType
            : '/api/slots/' + this.selectedOrgId + '/' + this.meetingType;
        const slotsData = http.get(path);
        slotsData.then((response: any) => {
            const data = response.json();
            data.then((reponse: Slot[]) => {
                this.slots = reponse as Slot[];
                this.slotsLoaded = true;
            }).catch((e: any) => {
                console.error(e);
            });
        });
    }
    private getPersons() {
        this.personsLoaded = false;
        const path = this.isRetailerSite ? '/api/persons/' : '/api/persons/' + this.selectedOrgId;
        const personsData = http.get(path);
        personsData.then((response: any) => {
            const data = response.json();
            data.then((reponse: Person[]) => {
                this.persons = reponse as Person[];
                window.scrollTo({ top: 1024, behavior: 'smooth' });
                if (this.$attrs['data-selected-person'] !== null) {
                    const selectedPerson = this.persons.find((x: Person) => {
                        return x.id === this.$attrs['data-selected-person'];
                    });
                    MeetingCalendarStore.setSelectedMeetingPerson(selectedPerson);
                }
                this.personsLoaded = true;

            }).catch((e: any) => {
                this.personsLoaded = true;

                console.error(e);
            });
        });
    }
}
